<template>
  <div class="del-popup-component" :style="height">
    <div class="del-popup-container" ref="delFacility">
      <div class="global_popup_header">
        {{ title || $t("commonMsg.tips")
        }}<i @click="$store.commit('windowHandle')"></i>
      </div>
      <div class="global_popup_body">
        {{ text || $t("alertMsg.unlockConfirm") }}
      </div>
      <div class="global_popup_footer">
        <button @click="confirm">{{ $t("commonMsg.confirm") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    }
  },
  data() {
    return {
      height: ""
    };
  },
  methods: {
    confirm() {
      this.$emit("delHandleFacilitys");
      this.$store.commit("windowHandle");
    }
  },
  mounted() {
    this.height = `height: ${this.$refs.delFacility.clientHeight}px`;
  }
};
</script>

<style lang="scss">
.del-popup-component {
  @include globalPopup();
  .del-popup-container {
    background: #fff;
    border-radius: 4px;
  }
  .global_popup_body {
    height: 80px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
